import { useDispatch } from 'react-redux';
import { useState } from 'react';
import {
  closeUsisConfirmDeactivateModal,
  openUsisConfirmDeactivateModal, toggleUsisCommonModal,
  toggleUsisModal,
} from '../../actions';
import { ESIA_USIS_MODAL_STEPS } from '../../constants';
import { redirectByEsiaAutoUrl, redirectByEsiaOnceUrl } from '../../../../requests/esiaUsis';

export const useModalContainerInit = ({
  step,
  commonStep,
  modalData,
  commonModalsData,
  redirectToEsiaUrl,
  isModalConfirmDeactivateOpened,
  modalVariant,
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  let handlersMainBtn = {
    main: () => null,
    additional: () => null,
  };

  let handlersBtn = {
    main: () => null,
    additional: () => null,
  };

  const handleOnCloseModal = () => {
    if (!isModalConfirmDeactivateOpened) {
      dispatch(toggleUsisModal(false));
    }
  };

  const handleOnCloseCommonModal = () => {
    if (!isModalConfirmDeactivateOpened) {
      dispatch(toggleUsisCommonModal(false));
    }
  };

  // Handlers для модалки с шагом Confirm Deactivate
  const handlersCMBtn = {
    main: () => {
      dispatch(closeUsisConfirmDeactivateModal());
      dispatch(toggleUsisModal(false));
    },
    additional: (url) => {
      dispatch(closeUsisConfirmDeactivateModal());
      dispatch(toggleUsisModal(false));
      window.open(url, '_self', 'noopener, noreferrer');
    },
  };

  const performRedirect = async (redirectFn) => {
    setIsLoading(true);
    await dispatch(redirectFn());
    setIsLoading(false);
    handleOnCloseModal();
  };

  const handleRedirect = (cbFn) => {
    performRedirect(cbFn).catch((error) => {
      console.error(`Error in handleRedirect: ${error}`);
    });
  };

  switch (step) {
    case ESIA_USIS_MODAL_STEPS.MAIN:
      const params = modalData?.mainParams?.[modalVariant];

      handlersMainBtn = {
        main: () => {
          if (modalVariant === 'once') {
            handleRedirect(redirectByEsiaOnceUrl(params));
          } else {
            handleRedirect(redirectByEsiaAutoUrl(params));
          }
        },
        additional: () => handleOnCloseModal(),
      };
      break;
    case ESIA_USIS_MODAL_STEPS.outdatedDataError:
      handlersMainBtn = {
        main: () => {
          dispatch(toggleUsisModal(false));
          window.open(redirectToEsiaUrl, '_self');
        },
        additional: () => dispatch(openUsisConfirmDeactivateModal()),
      };
      break;
    case ESIA_USIS_MODAL_STEPS.SERVICE_TIED:
      handlersMainBtn = {
        main: () => handleOnCloseModal(),
        additional: () => dispatch(openUsisConfirmDeactivateModal()),
      };
      break;
    case ESIA_USIS_MODAL_STEPS.notConfirmedDataError:
      const paramsForNotConfirmedDataError = commonModalsData?.[step]?.buttonGroup[0]?.params;

      handlersMainBtn = {
        main: () => handleRedirect(redirectByEsiaAutoUrl(paramsForNotConfirmedDataError)),
        additional: () => dispatch(openUsisConfirmDeactivateModal()),
      };
      break;
    default:
      handlersMainBtn = {
        main: () => handleOnCloseModal(),
      };
  }

  switch (commonStep) {
    case ESIA_USIS_MODAL_STEPS.CONFIRM_DEACTIVATE:
      handlersBtn = {
        additional: () => window.open(redirectToEsiaUrl, '_self'),
      };
      break;
    case ESIA_USIS_MODAL_STEPS.refusePermissionByUser:
      handlersBtn = {
        main: () => handleRedirect(redirectByEsiaAutoUrl),
      };
      break;
    default:
      handlersBtn = {
        main: () => {
          handleOnCloseCommonModal();
        },
      };
  }

  return {
    mainInfoData: {
      handleOnCloseModal,
      handlersMainBtn,
      isLoading,
      modalData,
      headerTitle: modalData?.title,
      isDisabledMainBtn: !modalVariant,
    },
    mainAdditionalModal: {
      dataMainAdditional: commonModalsData?.[step],
      handleOnCloseModal,
      handlersMainBtn,
      isLoading,
    },
    commonData: {
      data: commonModalsData?.[commonStep],
      handleOnCloseCommonModal,
      handlersBtn,
      isLoading,
    },
    confirmDeactivateModalData: {
      handlersCMBtn,
      dataCM: commonModalsData?.[ESIA_USIS_MODAL_STEPS.CONFIRM_DEACTIVATE],
    },
  };
};
